/* global ReactSpringserveComponent */

angular.module("vastdesk").component("bulkExportModal", {
  bindings: {
    singularLabel: "@",
    pluralLabel: "@",
    exportApiPath: "@",
  },
  template: require("../templates/bulkExportModal.html"),
  controllerAs: "$bulkExportModalCtrl",
  controller: [
    "$scope",
    "$rootScope",
    function ($scope, $rootScope) {
      const self = this;

      this.rootId = `component-root-angular-ModalBulkExport-${Math.floor(Math.random() * 2 ** 52)}`;

      this.open = false;
      this.selectedIds = [];
      this.unregisterWatcher = null;

      this.handleOpenChange = (open) => {
        self.open = open;
        $scope.$apply();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: 'ModalBulkExport',
            rootId: self.rootId,
            componentProps: {
              open: self.open,
              onOpenChange: self.handleOpenChange,
              selectedIds: self.selectedIds,
              singularLabel: self.singularLabel,
              pluralLabel: self.pluralLabel,
              exportApiPath: self.exportApiPath,
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watchGroup(
            [
              '$bulkExportModalCtrl.open',
              '$bulkExportModalCtrl.selectedIds',
            ],
            ([_open, _selectedIds]) => {
              self.renderReactComponent();
            }
          );
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
      };

      $rootScope.$on("bulkEditBroadcast", (event, args) => {
        if (args.id === "react_export") {
          // copy the selected id array to guard against us accidentally clobbering it in a way that would break the AngularJS side
          self.selectedIds = Array.isArray(args.selectedIds)
            ? args.selectedIds.slice()
            : [];
          self.open = true;
        }
      });
    },
  ],
});
